export default __webpack_public_path__ + "static/media/helpCode.09b29348.png";